import styled from 'styled-components';

export const SeverityColor = styled.div`
    border-radius: 6px;
    height: 20px;
    width: 20px;
`;